import React from 'react';

//Components.
import ChallengeCoverCard from '../../card-component/challenge-card-component/ChallengeCoverCard';

//Dependencies.
import { Container } from 'reactstrap'
import { useDispatch, useSelector } from 'react-redux';

//Slice Data.
import { completedChallenges } from '../../../slices/challengesSlice';

import './CompletedChallengesComponent.styles.css';


const CompletedChallengesComponent = () => {
   const challengesCompleted = useSelector(completedChallenges);
   
   return (
      <>
         <h1 style={{display: 'flex', justifyContent: 'center'}}>RECENT CHALLENGES COMPLETED.</h1>
         <Container className='p-3 completedChallengesContainer' style={{ border: '1.5px solid black' }}>
            {
               Object.values(challengesCompleted).map(val => <ChallengeCoverCard key={val._challengeID} {...val} />)
                  .reverse()
                  .slice(0, 3)
            }        
         </Container>
      </>
     
   )
}

export default CompletedChallengesComponent